<template>
  <div class="partner-page">
    <div class="page-inner">
      <h1 class="page-title">联系我们</h1>

      <div class="contact-card">
        <div class="contact-item">
          <span class="contact-label">公司地址</span>
          <span class="contact-value">河南省焦作市温县岳村街道黄河路北慈胜大街西东起第20号</span>
        </div>

        <div class="contact-item">
          <span class="contact-label">联系方式</span>
          <span class="contact-value">17739169525</span>
        </div>
      </div>

      <p class="contact-welcome">欢迎热爱中医文化的单位和个人联系垂询。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Partner",
};
</script>

<style scoped>
.partner-page {
  width: 100%;
  min-height: 520px;
  box-sizing: border-box;
  padding: 8px 20px 40px;
}

.page-inner {
  width: 100%;
  max-width: 880px;
  margin: 0 auto;
}

.page-title {
  margin: 20px 0 24px;
  font-size: 30px;
  font-weight: 700;
  color: #304744;
  letter-spacing: 1px;
  text-align: center;
}

.contact-card {
  padding: 30px 34px;
  border: 1px solid #e9efec;
  border-radius: 18px;
  background: #fbfdfc;
}

.contact-item {
  display: flex;
  align-items: flex-start;
  gap: 18px;
  padding: 16px 0;
}

.contact-item + .contact-item {
  border-top: 1px dashed #dcebe7;
}

.contact-label {
  flex-shrink: 0;
  width: 96px;
  font-size: 18px;
  font-weight: 600;
  color: #009798;
  line-height: 32px;
}

.contact-value {
  flex: 1;
  min-width: 0;
  font-size: 18px;
  line-height: 32px;
  color: #304744;
  word-break: break-all;
}

.contact-welcome {
  margin: 26px 0 0;
  font-size: 18px;
  line-height: 32px;
  color: #527f77;
  text-align: center;
}

@media (max-width: 768px) {
  .partner-page {
    padding: 8px 16px 32px;
  }

  .page-title {
    font-size: 24px;
  }

  .contact-card {
    padding: 20px 18px;
  }

  .contact-item {
    flex-direction: column;
    gap: 6px;
  }

  .contact-label {
    width: auto;
  }

  .contact-label,
  .contact-value,
  .contact-welcome {
    font-size: 16px;
    line-height: 28px;
  }
}
</style>
